export enum UserRole {
  Admin = "admin",
  SuperUser = "superuser",
  Customer = "customer",
}

export function getAsChoices<T extends Record<string, string>>(
  enumType: T
): { [key in T[keyof T]]: string } {
  return Object.keys(enumType).reduce((acc, key) => {
    const spacedTitleCase = key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
    acc[enumType[key as keyof T] as T[keyof T]] = spacedTitleCase;
    return acc;
  }, {} as { [key in T[keyof T]]: string });
}
